export const ProductsSection = () => `
  <section id="products" class="py-20 bg-white">
    <div class="container mx-auto px-6">
      <div class="text-center mb-16" data-aos="fade-up">
        <h2 class="text-4xl font-bold mb-6">Våre Populære Produkter</h2>
        <p class="text-xl text-gray-600 max-w-3xl mx-auto">
          Kvalitetsprodukter designet for moderne familier
        </p>
      </div>
      
      <div class="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
        ${[
          {
            name: 'Foldbar Krakk',
            image: 'https://farskapet.no/cdn/shop/files/sagababy-sammenleggbar-krakk-sikker-og-plassbesparende-923822.webp?v=1733298631&width=1100',
            price: '579',
            originalPrice: '899',
            description: 'Praktisk og sammenleggbar krakk for barn',
            features: ['Lett å folde sammen', 'Stabil og sikker', 'Perfekt høyde'],
            link: 'https://farskapet.no/products/sagababy-sammenleggbar-krakk?utm_source=landing_page&utm_medium=product_card&utm_campaign=sagababy_products'
          },
          {
            name: 'Sagababy Sklie',
            image: 'https://farskapet.no/cdn/shop/files/sagababy-sammenleggbar-sklie-er-den-ultimate-2-i-1-losningen-931939.jpg?v=1733557767&width=1100',
            price: '2220',
            originalPrice: '3100',
            description: 'Morsom sklie for inne- og utebruk',
            features: ['Enkel å sette opp', 'Kompakt oppbevaring', 'Sikker og robust'],
            link: 'https://farskapet.no/products/sagababy-sammenleggbar-sklie?utm_source=landing_page&utm_medium=product_card&utm_campaign=sagababy_products'
          },
          {
            name: 'Kjøkkenhjelper',
            image: 'https://farskapet.no/cdn/shop/files/sagababy-kjokkenhjelper-trygg-og-praktisk-hjelp-for-pappa-597562.jpg?v=1733557770&width=1100',
            price: '1350',
            description: 'Trygg og praktisk kjøkkenhjelp for barn',
            features: ['Justerbar høyde', 'Sikkerhetsfunksjoner', 'Stabil konstruksjon'],
            link: 'https://farskapet.no/products/sagababy-kjokkenhjelper?utm_source=landing_page&utm_medium=product_card&utm_campaign=sagababy_products'
          },
          {
            name: 'Stellematte',
            image: 'https://i0.wp.com/farskapet.no/wp-content/uploads/2024/10/Stelle-matterr-scaled.webp?fit=2560%2C2560&ssl=1',
            price: '699',
            description: 'Praktisk og komfortabel stellematte',
            features: ['Lett å rengjøre', 'Myk og behagelig', 'Sammenleggbar'],
            link: 'https://farskapet.no/products/sagababy-stellematte?utm_source=landing_page&utm_medium=product_card&utm_campaign=sagababy_products'
          }
        ].map(product => `
          <div class="product-card" data-aos="fade-up">
            <div class="product-image">
              <img src="${product.image}" alt="${product.name}" class="w-full h-full object-cover">
              <div class="absolute top-4 right-4 bg-secondary text-white px-4 py-2 rounded-full">
                ${product.originalPrice ? `
                  <span class="line-through text-white/70">${product.originalPrice} NOK</span><br>
                  <span class="font-bold">${product.price} NOK</span>
                ` : `
                  Fra ${product.price} NOK
                `}
              </div>
            </div>
            <div class="p-6">
              <h3 class="text-xl font-bold mb-2">${product.name}</h3>
              <p class="text-gray-600 mb-4">${product.description}</p>
              <ul class="space-y-2 mb-6">
                ${product.features.map(feature => `
                  <li class="flex items-center gap-2">
                    <svg class="w-5 h-5 text-secondary" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"/>
                    </svg>
                    ${feature}
                  </li>
                `).join('')}
              </ul>
              <a href="${product.link}" target="_blank" class="shine-button w-full py-3 rounded-lg text-white text-center block">
                Kjøp Nå
              </a>
            </div>
          </div>
        `).join('')}
      </div>
    </div>
  </section>
`;